import React, { useState } from 'react';
import { COLORS } from '../../../../utils/constants';
import { adminAPI } from '../../../../services/api';
import { useAdminToast } from '../../../../hooks/useAdminToast';
import { ModalWrapper, FormInput } from './ModalComponents';

const EditClientModal = ({ client, managers, statuses, onClose, onSuccess }) => {
  const { toast } = useAdminToast();
  const [form, setForm] = useState({
    name: client?.name || '',
    email: client?.email || '',
    phone: client?.phone || '',
    admin_phone: client?.admin_phone || '',
    client_status: client?.client_status || 'NEW',
    assigned_to: client?.assigned_to || '',
    is_active: client?.is_active ?? true,
    language: client?.language || 'ru',
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await adminAPI.fullUpdateClient(client.id, form);
      onSuccess();
    } catch (err) {
      toast.apiError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalWrapper title="Редактирование клиента" onClose={onClose}>
      <div style={{ display: 'grid', gap: '12px' }}>
        <FormInput label="Имя" value={form.name} onChange={(v) => setForm({ ...form, name: v })} />
        <FormInput label="Email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} type="email" />
        <FormInput label="Телефон (от клиента)" value={form.phone} onChange={(v) => setForm({ ...form, phone: v })} />
        <div style={{ position: 'relative' }}>
          <FormInput label="Телефон (от админа)" value={form.admin_phone} onChange={(v) => setForm({ ...form, admin_phone: v })} />
          <div style={{ fontSize: '11px', color: COLORS.textSecondary, marginTop: '-8px', marginBottom: '4px' }}>
            * Не отображается в профиле клиента
          </div>
        </div>
        
        <div>
          <label style={{ display: 'block', color: COLORS.textSecondary, fontSize: '13px', marginBottom: '6px' }}>Статус</label>
          <select 
            value={form.client_status} 
            onChange={(e) => setForm({ ...form, client_status: e.target.value })} 
            style={{ 
              width: '100%', 
              padding: '12px', 
              backgroundColor: COLORS.background, 
              border: `1px solid ${COLORS.border}`, 
              borderRadius: '8px', 
              color: COLORS.text, 
              fontSize: '14px' 
            }}
          >
            {statuses.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>

        <div>
          <label style={{ display: 'block', color: COLORS.textSecondary, fontSize: '13px', marginBottom: '6px' }}>Менеджер</label>
          <select 
            value={form.assigned_to} 
            onChange={(e) => setForm({ ...form, assigned_to: e.target.value })} 
            style={{ 
              width: '100%', 
              padding: '12px', 
              backgroundColor: COLORS.background, 
              border: `1px solid ${COLORS.border}`, 
              borderRadius: '8px', 
              color: COLORS.text, 
              fontSize: '14px' 
            }}
          >
            <option value="">Не назначен</option>
            {managers.map(m => <option key={m.id} value={m.id}>{m.name || m.email}</option>)}
          </select>
        </div>

        <div style={{ display: 'flex', gap: '16px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', color: COLORS.text, fontSize: '14px' }}>
            <input 
              type="checkbox" 
              checked={form.is_active} 
              onChange={(e) => setForm({ ...form, is_active: e.target.checked })} 
              style={{ width: '18px', height: '18px', accentColor: COLORS.primary }} 
            />
            Активен
          </label>
        </div>
      </div>

      <button 
        onClick={handleSubmit} 
        disabled={loading} 
        style={{ 
          width: '100%', 
          marginTop: '20px', 
          padding: '14px', 
          backgroundColor: loading ? COLORS.border : COLORS.primary, 
          border: 'none', 
          borderRadius: '8px', 
          color: loading ? COLORS.textSecondary : '#000', 
          fontSize: '15px', 
          fontWeight: '600', 
          cursor: loading ? 'not-allowed' : 'pointer' 
        }}
      >
        {loading ? 'Сохранение...' : 'Сохранить'}
      </button>
    </ModalWrapper>
  );
};

export default EditClientModal;
